/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IGoal {
  LoseWeight = 'Lose Weight',
  MuscleTone = 'Muscle Tone',
  Performance = 'Performance',
  HealthAndWellness = 'Health & Wellness',
}
